const contactUs = (state = {}, action) => {
    switch (action.type) {
        case 'CONTACT_US_DATA_LOADED_FORMS' : 
            return{
            ...state,
            contactForms : action.payload
            }
        case 'CONTACT_US_DATA_LOADED_PERSONS' : 
            return{
            ...state,
            contactPersons : action.payload
            }
        default:
            return state
        }
  }
  export default contactUs